import {
  PAYMENTS_INVOICES_PAGE,
  PAYMENTS_OVERVIEW_PAGE,
  PAYMENTS_PAYMENT_LINKS_PAGE,
  PAYMENTS_SERVICES_PAGE,
  PAYMENTS_STORE_PAGE,
  PAYMENTS_SUBSCRIPTIONS_PAGE,
} from 'src/constants';

export enum PaymentTab {
  Overview = 'overview',
  Invoices = 'invoices',
  Subscriptions = 'subscriptions',
  Store = 'store',
  PaymentLinks = 'payment-links',
  Services = 'services',
}

export interface PaymentTabDefinition {
  key: PaymentTab;
  label: string;
  path: string;
}

/**
 * The payments surface is one page with tabs, so this list is also what the
 * command bar offers — a tab added here must not need a second registration.
 */
export const paymentTabs: Array<PaymentTabDefinition> = [
  {
    key: PaymentTab.Overview,
    label: PAYMENTS_OVERVIEW_PAGE.label,
    path: PAYMENTS_OVERVIEW_PAGE.path,
  },
  {
    key: PaymentTab.Invoices,
    label: PAYMENTS_INVOICES_PAGE.label,
    path: PAYMENTS_INVOICES_PAGE.path,
  },
  {
    key: PaymentTab.Subscriptions,
    label: PAYMENTS_SUBSCRIPTIONS_PAGE.label,
    path: PAYMENTS_SUBSCRIPTIONS_PAGE.path,
  },
  {
    key: PaymentTab.Store,
    label: PAYMENTS_STORE_PAGE.label,
    path: PAYMENTS_STORE_PAGE.path,
  },
  {
    key: PaymentTab.PaymentLinks,
    label: 'Payment links',
    path: PAYMENTS_PAYMENT_LINKS_PAGE.path,
  },
  {
    key: PaymentTab.Services,
    label: PAYMENTS_SERVICES_PAGE.label,
    path: PAYMENTS_SERVICES_PAGE.path,
  },
];
